import React, { useMemo } from 'react';
import CarouselContext, { CarouselContextProps } from '@/context/CarouselContext';

interface CarouselProviderProps extends CarouselContextProps {
  children: React.ReactElement;
}

export default function CarouselProvider({ children, centerText, hoverImages }: CarouselProviderProps) {
  const contextValue = useMemo(() => ({ centerText, hoverImages }), [centerText, hoverImages]);

  return <CarouselContext.Provider value={contextValue}>{children}</CarouselContext.Provider>;
}
